"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var LayoutStyles_1 = require("../../style/LayoutStyles");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
// Styles from Vizportal "Spaces Explorer"
var ItemContainer = LayoutComponents_1.divWithStyle('ItemContainer', __assign(__assign({}, LayoutStyles_1.flexRowStyle), { justifyContent: 'space-between', whiteSpace: 'nowrap', padding: '6px 0', fontFamily: VizPortalStyles_1.vizPortalFontStyle.fontFamily }));
var CountLabel = LayoutComponents_1.divWithStyle('CountLabel', {
    minWidth: 36,
    marginLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    textAlign: 'right',
    color: widgets_1.TabStyles.Typography.Color.Disabled
});
function CatalogBrowserSelectorItem(props) {
    return (React.createElement(ItemContainer, null,
        React.createElement("div", null, props.subplaceName),
        React.createElement(CountLabel, null, props.count)));
}
exports.CatalogBrowserSelectorItem = CatalogBrowserSelectorItem;
//# sourceMappingURL=CatalogBrowserSelectorItem.js.map